<template>
  <div
    class="bv-tabbed-navigation"
    role="tablist"
  >
    <div class="bv-tabbed-navigation__options">
      <button
        id="tab-reviews"
        role="tab"
        :aria-selected="displayingReviews"
        aria-controls="bv-tabs-content-reviews"
        :class="[
          'bv-tabbed-navigation__options-btn',
          { 'bv-tabbed-navigation__options-btn--active': displayingReviews },
        ]"
        :tabindex="activeTab === 0 ? '0' : '-1'"
        @click="displayReviewsTab(true)"
        @focus="focusTab(0)"
        @keyup.right="displayReviewsTab(false), focusOn('tab-questions')"
      >
        {{ reviewsLabel }}
      </button>
      <button
        id="tab-questions"
        role="tab"
        :aria-selected="!displayingReviews"
        aria-controls="bv-tabs-content-questions"
        :class="[
          'bv-tabbed-navigation__options-btn',
          { 'bv-tabbed-navigation__options-btn--active': !displayingReviews },
        ]"
        :tabindex="activeTab === 1 ? '0' : '-1'"
        @click="displayReviewsTab(false)"
        @focus="focusTab(1)"
        @keyup.left="displayReviewsTab(true), focusOn('tab-reviews')"
      >
        {{ questionsLabel }}
      </button>
    </div>

    <div class="bv-tabbed-navigation__content">
      <div
        v-show="displayingReviews"
        id="bv-tabs-content-reviews"
        :aria-hidden="!displayingReviews"
        aria-labelledby="tab-reviews"
        role="tabpanel"
        tabindex="0"
      >
        <slot name="reviews" />
      </div>
      <div
        v-show="!displayingReviews"
        id="bv-tabs-content-questions"
        :aria-hidden="displayingReviews"
        aria-labelledby="tab-questions"
        role="tabpanel"
        tabindex="0"
      >
        <slot name="questions" />
      </div>
    </div>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  export default {
    name: 'BvTabbedNavigation',
    props: {
      reviewsLabel: { type: String, required: false, default: 'Reviews & Ratings' },
      questionsLabel: { type: String, required: false, default: 'Questions & Answers' },
      productId: { type: String, required: false },
      productName: { type: String, required: false },
      pageCategory: { type: String, required: false },
    },
    data() {
      return {
        displayingReviews: true,
        activeTab: 0,
      };
    },
    methods: {
      displayReviewsTab(display) {
        this.displayingReviews = display;

        AnalyticsHandler.pushDataLayer({
          ecommerce: undefined,
          event: 'nievent',
          eventAction: 'select',
          eventCategory: this.pageCategory,
          eventLabel: display ? 'reviews' : 'questions',
          event_name: 'product_info_click',
          product_tab: display ? 'reviews' : 'questions',
          product_info: `${this.productName}::${this.productId}`,
        });
      },
      focusTab(tabIndex) {
        this.activeTab = tabIndex;
      },
      focusOn(id) {
        document.getElementById(id).focus();
      },
    },
  };
</script>
